import {extendTheme} from "@chakra-ui/react";

export const theme = extendTheme({
  fonts: {
    heading: "Raleway, sans-serif",
    body: "Montserrat, sans-serif"
  },
  colors: {
    brandPrimary: {
      50: "#ECF5DA",
      100: "#D1ECBD",
      200: "#AEE2A1",
      300: "#86D887",
      400: "#6BCD83",
      500: "#51C185",
      600: "#45AB8A",
      700: "#3A948A",
      800: "#2F747C",
      900: "#255064"
    },
    primaryComponentBg: {
      500: "#f2f2f2"
    },
    accentComponentBg: {
      500: "#314047"
    },
    darkAccentBg: {
      500: "#1B2527"
    },
    lightGray: "#f2f2f2",
    black: "#1E1E1E",
    primary: {
      50: "#E8EDFF",
      100: "#D5DBFF",
      200: "#A5BAFF",
      300: "#6E94FF",
      400: "#0055C6",
      500: "#004AAD",
      600: "#00337C",
      700: "#00265E",
      800: "#01143C",
      900: "#000C2A"
    },
    secondary: {
      50: "#FFF9F2",
      100: "#FFF2E5",
      200: "#FFE4C8",
      300: "#FFD6A8",
      400: "#FFC880",
      500: "#FFB93C",
      600: "#CC9100",
      700: "#9d7103",
      800: "#875f01",
      900: "#5d4200"
    }
  }
});
